import request from "@/utils/request";

export function getMockDataByZoneId(zoneId) {
    return request({
        url: `/dashboard/getMockData?zoneId=${zoneId}`,
        method: "get",
    });
}
export function updateById(data) {
    return request({
        url: "/dashboard/updateMockData",
        method: "post",
        data,
    });
}